export class JobQueue {
  private queue: {
    job: () => Promise<any>;
    resolve: (value: any) => void;
    reject: (reason?: any) => void;
  }[] = [];
  private activeCount = 0;
  private readonly concurrencyLimit: number;
  private readonly requestInterval: number;
  private pendingJobs = new Map<string, Promise<any>>();

  constructor(concurrencyLimit: number, requestInterval: number) {
    this.concurrencyLimit = concurrencyLimit;
    this.requestInterval = requestInterval;
  }

  public enqueueUnique<T>(key: string, job: () => Promise<T>): Promise<T> {
    const existingJob = this.pendingJobs.get(key);

    if (existingJob) return existingJob as Promise<T>;

    const promise = this.enqueue(job).finally(() => {
      this.pendingJobs.delete(key);
    });

    this.pendingJobs.set(key, promise);
    return promise;
  }

  private enqueue<T>(job: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue.push({ job, reject, resolve });
      this.dequeue();
    });
  }

  private async dequeue() {
    if (this.queue.length === 0 || this.activeCount >= this.concurrencyLimit) {
      return;
    }

    this.activeCount++;
    const { job, resolve, reject } = this.queue.shift();

    try {
      const result = await job();
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      this.activeCount--;
      setTimeout(() => {
        this.dequeue();
      }, this.requestInterval);
    }
  }
}
